const messages = {
    en: {
        delivery: {
            empty: {
                items: 'Your orderSystem is empty',
                minimunQuantity: 'The minimum quantity of products is {quantity}',
                deliveryMode: 'You must choose the delivery mode "take away" or "delivery".',
                time: 'You must choose the delivery time',
                location: 'You must indicate your address',
                contact: 'Contact details missing',
                paymentMethod: 'You must choose a payment method',
                minimunCategoryQuantityNotReached: 'The minimum category quantity is not reached',
            },
        },
    },
    es: {
        delivery: {
            empty: {
                items: 'Su pedido esta vacío',
                minimunQuantity: 'La cantidad minima de productos es {quantity}',
                deliveryMode: 'Debe elegir el modo de envío "take away" o "delivery".',
                time: 'Debes elegir la hora de entrega',
                location: 'Debes indicar tu dirección',
                contact: 'Faltan datos de contacto',
                paymentMethod: 'Debe elegir un método de pago',
                minimunCategoryQuantityNotReached: 'El mínimo de cantidad de productos por categorías no fue alcanzado',
            },

        }
    },
    pt: {
        delivery: {
            empty: {
                items: 'Su pedido esta vacío',
                minimunQuantity: 'La cantidad minima de productos es {quantity}',
                deliveryMode: 'Debe elegir el modo de envío "take away" o "delivery".',
                time: 'Debes elegir la hora de entrega',
                location: 'Debes indicar tu dirección',
                contact: 'Faltan datos de contacto',
                paymentMethod: 'Debe elegir un método de pago',
                minimunCategoryQuantityNotReached: 'El mínimo de cantidad de productos por categorías no fue alcanzado',
            },
        }
    }

}

export default messages
